import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientDiagnosisControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  patientUuid: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: boolean;
  archive?: boolean;
  searchString?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientDiagnosesList = ({
  patientUuid,
  pagination,
  gridSorting,
  status,
  archive,
  searchString,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);
  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "patient-diagnoses-list",
      patientUuid,
      pageIndex,
      pageSize,
      gridSorting,
      status,
      archive,
      searchString,
      xTENANTID,
      sortData,
    ],

    refetchOnWindowFocus: false,

    placeholderData: keepPreviousData,
    enabled: enabled,
    queryFn: async () =>
      await new PatientDiagnosisControllerApi(getConfigObject())
        .getPatientDiagnosis(
          patientUuid,
          pageIndex, //page
          pageSize, //size
          sortData?.field, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          status,
          archive,
          searchString,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
